import { render, staticRenderFns } from "./masterMaterialPrize.vue?vue&type=template&id=a580bff6"
import script from "./masterMaterialPrize.vue?vue&type=script&lang=js"
export * from "./masterMaterialPrize.vue?vue&type=script&lang=js"
import style0 from "./masterMaterialPrize.vue?vue&type=style&index=0&id=a580bff6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_21c2e229d51f918cc63b499183bc63cd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports